<div
  class="pt-4 flex flex-col"
  [ngClass]="{
    'mt-16': hasImage,
    'mx-3': rowTitle,
    'w-4/5 lg:w-full justify-self-center': hasImage,
    'slider-no-value': !sliderValue,
  }"
>
  <div
    class="relative w-full"
    [ngClass]="inMatrix ? '' : 'pt-8'"
    [style.padding-top.px]="inMatrix ? matrixTrackTopPaddingPx : null"
  >
    <input
      #rangeInput
      type="range"
      [id]="question.id"
      [formControl]="control"
      (change)="onSliderChange($event)"
      [value]="selectedAlternativeIndex"
      [min]="0"
      [max]="question.alternatives.length - 1"
      [step]="1"
      (input)="updateTooltip($event)"
      class="w-full h-2 cursor-pointer peer"
      [ngClass]="sliderValue ? 'accent-inherit' : 'accent-gray-500'"
      [attr.aria-valuenow]="sliderValue"
      [attr.aria-label]="
        (rowTitle ? rowTitle + ' - ' : '') +
        ('question.slider.arialabel.prefix' | translate) +
        question.slider?.startLabel +
        ('question.slider.arialabel.separator' | translate) +
        question.slider?.endLabel
      "
    />
    @if (sliderValue) {
      @if (hasImage) {
        @if (
          question.slider?.showSliderValues &&
          !question.alternatives[control.value].image?.hideTitle
        ) {
          <div
            [id]="'slider-' + question.id"
            class="absolute transform -translate-x-1/2 bg-gray-800 text-white text-sm px-2 pointer-events-none text-center"
            [class.whitespace-nowrap]="
              !question.alternatives[control.value].image?.width
            "
            [ngStyle]="{
              'left.px': tooltipPosition,
              'top.px': -(
                0 + (question.alternatives[control.value].image?.height || 5)
              ),
              'min-width.px':
                question.alternatives[control.value].image?.width || null,
            }"
          >
            {{ sliderValue }}
            <div
              class="absolute left-1/2 transform -translate-x-1/2 -bottom-1 w-2 h-2 bg-gray-800 rotate-45"
            ></div>
          </div>
        }
        <div
          [id]="'slider-' + question.id"
          class="relative top-[-40px] transform -translate-x-1/2 pointer-events-none"
          [ngStyle]="{
            'left.px': tooltipPosition,
          }"
        >
          <img
            class="absolute left-1/2 transform -translate-x-1/2 -bottom-1 h-full w-full"
            [src]="question.alternatives[control.value].image?.url"
            [style.width.px]="question.alternatives[control.value].image?.width"
            [style.height.px]="
              question.alternatives[control.value].image?.height
            "
            [alt]="
              question.alternatives[control.value].image?.alternateText ||
              question.alternatives[control.value].title
            "
          />
        </div>
      } @else {
        @if (question.slider?.showSliderValues) {
          <div
            [id]="'slider-' + question.id"
            class="absolute top-[-25px] transform -translate-x-1/2 bg-gray-800 text-white whitespace-nowrap pointer-events-none"
            [ngClass]="
              inMatrix ? 'text-base py-0.5 px-2 z-[200]' : 'text-lg py-1 px-4'
            "
            [ngStyle]="{ 'left.px': tooltipPosition }"
          >
            {{ sliderValue }}
            <div
              class="absolute left-1/2 transform -translate-x-1/2 -bottom-1 w-2 h-2 bg-gray-800 rotate-45"
            ></div>
          </div>
        }
      }
    }
  </div>
  <div #belowContent class="flex flex-col">
    <div
      class="flex justify-between"
      [ngClass]="inMatrix ? 'mt-4 text-base' : 'mt-9 text-xl'"
    >
      <span class="w-2/5">{{ question.slider?.startLabel }}</span>
      <span class="w-2/5 text-right">{{ question.slider?.endLabel }}</span>
    </div>
    @if (question.slider?.canRemoveAnswer) {
      <app-button
        [buttonId]="'clear-value'"
        [buttonText]="'question.slider.clear.button' | translate"
        (buttonClick)="clearValue()"
        [disabled]="!sliderValue"
        class="flex self-center"
        [customClasses]="
          inMatrix
            ? 'reset-button reset-button-matrix mt-1 px-6 lg:hover:scale-110'
            : 'reset-button mt-4 px-6 lg:hover:scale-110'
        "
      ></app-button>
    }
  </div>
</div>
